"use client";

import React, { useContext } from "react";
import { ThemeContext } from "./ThemeWrapper";
import { Moon, SunMedium } from "lucide-react";

interface ThemeSwitchButtonProps {
  theme_style: "adapt" | "adapt-reverse" | "light" | "dark";
}

export default function ThemeSwitchButton({
  theme_style = "adapt",
}: Readonly<ThemeSwitchButtonProps>) {
  const theme = useContext(ThemeContext);

  const toggleTheme = () => {
    // Swap theme
    const newTheme = theme === "light" ? "dark" : "light";
    localStorage.setItem("theme", newTheme);
    dispatchEvent(new Event("storage"));
  };

  let color_value = "";
  let reverse_color_value = "";

  switch (theme_style) {
    case "adapt":
      color_value = "c-bg-secondary";
      reverse_color_value = "c-bg";
      break;
    case "adapt-reverse":
      color_value = "c-bg";
      reverse_color_value = "c-bg-secondary";
      break;
    case "light":
      color_value = "c-dark";
      reverse_color_value = "c-light";
      break;
    case "dark":
      color_value = "c-light";
      reverse_color_value = "c-dark";
      break;
  }

  const _tailwind_css =
    "fill-c-bg-secondary fill-c-bg fill-c-dark fill-c-light text-c-bg-secondary text-c-bg text-c-dark text-c-light bg-c-bg-secondary bg-c-bg bg-c-dark bg-c-light border-c-bg-secondary border-c-bg border-c-dark border-c-light";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={`
        border-2 border-${color_value} rounded-full bg-${reverse_color_value}
        text-${color_value}
        overflow-clip
        scale-90
        h-fit
        ignore-theme-transition
        my-auto
        `}
    >
      <div className="relative flex gap-3 p-1">
        <div
          className={`
                h-9 w-9 rounded-full absolute top-1/2 -translate-y-1/2
                bg-${color_value}
                transition-all ease-in-out
                ${theme === "dark" ? "left-0" : "left-full -translate-x-full"}
                `}
        />
        <Moon size={24} className={`fill-${color_value}`} />
        <SunMedium size={24} className={`fill-${color_value}`} />
      </div>
    </button>
  );
}
